import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { SkipToContent } from '@/components/ui/SkipToContent'
import { ScrollToTop } from '@/components/ui/ScrollToTop'
import { CookieBanner } from '@/components/ui/CookieBanner'
import { ChatBot } from '@/components/ChatBot/ChatBot'
import { CTASection } from '@/components/shared/CTASection'

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipToContent />
      <Header />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <CTASection />
      <Footer />
      <ChatBot />
      <CookieBanner />
      <ScrollToTop />
    </div>
  )
}
